import corporateContractApprovals from "./corporateContractApprovals.component";
import corporateContractApprovalsUrls from "./corporateContractApprovals.urls";
import CorporateContractApprovalsTransforms from "./corporateContractApprovals.transforms";

const corporateContractApprovalsModule = angular
  .module("app.components.corporateContractApprovals", [])
  .component("corporateContractApprovalsPage", corporateContractApprovals)
  .service(
    "CorporateContractApprovalsTransforms",
    CorporateContractApprovalsTransforms
  )
  .config(corporateContractApprovalsUrls);

export default corporateContractApprovalsModule;



// WEBPACK FOOTER //
// ./src/pages/corporateContractApprovals/corporateContractApprovals.module.js